module.exports = __webpack_public_path__ + "img/4-mob-wide.db488311.png";